export class ReAssignReleaseDto {
  workItemId: any[] = [];
  queueId: number = 0;
  workFlowId: number = 0;
  assignUserGpid: string = '';
  owningUser: string = '';
  userGpid: string = '';
  systemId: number = 0;
}
